<template lang="pug">
  div(style="height: 5%;top: 95%;")
    div(
      ref="parent"
      style="width: 100%; height: 100%;  display: flex; justify-content: center; align-items: center")
      div.indicators(
        v-for="i in length"
        ref="indicators")
</template>

<script>
import Vue from 'vue'
import { ref, onMounted, onUnmounted, watchEffect, watch, reactive, toRefs } from '@vue/composition-api'
import { gsap } from 'gsap'
import useWindow from '@iez/lib/use-window'
import { clamp } from 'lodash'
import { theme } from '@iez/core'

export default {
  props: {
    length: Number,
    progress: Number
  },

  setup (props) {
    const indicators = ref(null)
    const parent = ref(null)
    const size = 9
    const space = 6
    const spacing = (size + space * 2)
    const background = theme.indicator.color

    const state = reactive({
      index: 0
    })

    const timeline = gsap.timeline({
      paused: true
    })

    const window = useWindow()

    onUnmounted(() => {
      timeline.kill()
    })

    onMounted(() => {
      const children = indicators.value

      const container = parent.value

      const active = children[0].cloneNode(true)
      container.appendChild(active)

      const init = () => {
        timeline.pause(0)
        timeline.clear()
        if (!children[0]) {
          return
        }

        const containerDimension = container.getBoundingClientRect()
        const childrenSize = (size + space) * props.length

        children.forEach((child, i) => {
          gsap.set(child, {
            width: size,
            height: size,
            borderRadius: size,
            background,
            marginLeft: i !== 0 ? spacing : 0
          })
        })

        Vue.nextTick(() => {
          const rectangle = children[0].getBoundingClientRect()
          gsap.set(active, {
            background: theme.primary.color,
            zIndex: 2,
            id: 'active',
            width: size,
            height: size,
            borderRadius: size,
            position: 'absolute',
            top: 0,
            left: 0,
            x: rectangle.x,
            y: rectangle.y
          })
          for (let i = 0 ; i < props.length ; ++i) {
            timeline.to(
              active,
              0.25, {
                width: spacing
              }
            )
            timeline.to(
              active,
              0.25, {
                width: spacing * 2,
                ease: 'power2.in'
              }
            )
            timeline.to(
              active,
              0.5, {
                width: size,
                x: rectangle.x + (spacing + size) * (i + 1)
              }
            )
          }
        })
      }

      watch(
        [
          () => window.width,
          () => window.height,
          () => props.length
        ],
        () => init(), {
          immediate: true
        }
      )

      watch(
        () => props.progress,
        () => {
          state.index = Math.floor(props.progress)
          timeline.seek(props.progress)
        }, {
          immediate: true
        }
      )
    })

    return {
      indicators,
      size,
      space,
      parent,
      ...toRefs(state)
    }
  }
}
</script>

<style scoped>
.indicators {

}
</style>
